/**
 * Slick slider
 */

document.addEventListener("DOMContentLoaded", (event) => {

  jQuery(function() {

    jQuery('.slider__for').each(function(key, item) {

      var sliderIdName = 'slider' + key;
      var sliderNavIdName = 'sliderNav' + key;

      this.id = sliderIdName;
      jQuery('.slider__nav')[key].id = sliderNavIdName;

      var sliderId = '#' + sliderIdName;
      var sliderNavId = '#' + sliderNavIdName;

      jQuery(sliderId).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        slide: 'div',
        infinite: false,
        prevArrow: jQuery(sliderId + ' .slick-prev'),
        nextArrow: jQuery(sliderId + ' .slick-next'),
        asNavFor: sliderNavId,
      });

      jQuery(sliderNavId).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true,
        //centerMode: true,
        infinite: false,
        asNavFor: sliderId,
      });
    });

    });

});
